import React from 'react';

export default function About() {
  return (
    <main>
      <section className="relative overflow-hidden bg-gradient-to-br from-brand via-brand/80 to-brand/50 text-white">
        <div className="section-container py-12 lg:py-16">
          <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr] lg:items-start">
            <div className="space-y-8">
              <div>
                <h1 className="text-4xl font-semibold">About Dr. Priya</h1>
              </div>

              <div className="flex justify-center lg:hidden">
                <img
                  className="w-full max-w-md rounded-none border border-white/10 object-cover shadow-soft"
                  src={`${process.env.PUBLIC_URL}/images/dr_priya.jpg`}
                  alt="Dr. Priya Bhave Chittawar"
                  fetchPriority="high"
                />
              </div>

              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-semibold">Academic Qualifications</h2>
                  <ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-white/90">
                    <li>M.B.B.S (1999)</li>
                    <li>M.D. (Obstetrics and Gynecology) 2003</li>
                    <li>D.N.B. (Obstetrics and Gynecology) 2006</li>
                    <li>M.R.C.O.G.(Part 1) 2008</li>
                    <li>Fellowship In Reproductive Medicine (Christian Medical College, Vellore) 2010</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-2xl font-semibold">Academic Achievements</h2>
                  <ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-white/90">
                    <li>Stood second in the first professional M.B.B.S. University examination.</li>
                    <li>Stood first in the second professional M.B.B.S. University examination.</li>
                    <li>Stood first in the final part I M.B.B.S. university examination.</li>
                    <li>Stood second in the final part II M.B.B.S. university examination.</li>
                    <li>Stood first in M.B.B.S. (overall) from 1994-1999.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="hidden justify-center lg:flex lg:justify-end">
              <img
                className="w-full max-w-md rounded-none border border-white/10 object-cover shadow-soft"
                src={`${process.env.PUBLIC_URL}/images/dr_priya.jpg`}
                alt="Dr. Priya Bhave Chittawar"
              />
            </div>
          </div>

          <div className="mt-10">
            <h2 className="text-2xl font-semibold">Research Projects</h2>
            <ul className="mt-4 list-disc space-y-3 pl-5 text-sm text-white/90">
              <li>Co-investigator in Project on 'Obstetric Outcome in Patients Referred to Tertiary Care Center' (Sponsored by Govt. of Madhya Pradesh).</li>
              <li>Principal investigator in Project on 'Predictors of I.U.I.' carried out in Reproductive Medicine Unit, Christian Medical College, Vellore.</li>
              <li>Principal investigator in Project on 'Use of GnRH antagonist on Pregnancy Rates in Stimulated I.U.I. Cycles' carried out in Reproductive Medicine Unit, Christian Medical College, Vellore. This was awarded the best research paper prize in the national conference of Indian Society of Assisted Reproduction in 2009 at Kochi.</li>
              <li>Best Research paper award at the National Conference of Indian Society for Assisted Reproduction (ISAR) at Raipur in 2012 on the paper "Hysteroscopy and Adenomyosis".</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="relative bg-slate-100">
        <div className="section-container py-12">
          <div className="space-y-10">
            <div>
              <h2 className="text-2xl font-semibold text-brand">Awards</h2>
              <ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-neutral/80">
                <li>The President of India Shri Shankar Dayal Sharma Award for the BEST MEDICAL STUDENT 1994-1999.</li>
                <li>The Suresh Kak Memorial award for BEST ALL ROUNDER MBBS 1994-1999.</li>
                <li>The Dr. Vishal Vikram Singh memorial award for HIGHEST MARKS IN MBBS 1994-1999.</li>
                <li>The M.P. State Chief Minister award for exceptional work in promoting institutional delivery with cash prize of Rs.25,000/- in 2007.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-brand">Accolades and Medals</h2>
              <ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-neutral/80">
                <li>'Late Shri P.C. Jain Gold Medal' for securing highest marks in Anatomy in 1996.</li>
                <li>'Dr. Arun Jain Gold Medal' for securing highest marks in Biochemistry in 1996.</li>
                <li>'Late Shri Jagannath Prasad Madhav Trophy' for securing first rank in second professional M.B.B.S. examination in 1997.</li>
                <li>'Late Smt. Narmada Bai Gold Medal' for securing highest marks in Forensic Medicine in 1997.</li>
                <li>'Shri Moti Ram Pant Gold Medal' for securing highest marks in Pharmacology in 'ShriJyoti Prasad Jain Gold Medal' for securing highest marks in Pathology in 1997.</li>
                <li>Certificate of Merit & Gold Medal for securing highest marks in Medicine in 1999.</li>
                <li>Gold medal for securing distinction in Anatomy.</li>
                <li>Gold medal for securing distinction in Biochemistry.</li>
                <li>Gold medal for securing distinction in Pathology.</li>
                <li>Gold medal for securing distinction in Pharmacology.</li>
                <li>Gold medal for securing distinction in Forensic Medicine.</li>
                <li>Gold medal for securing distinction in Ophthalmology.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-accent text-white">
        <div className="section-container py-12">
          <div className="space-y-6">
            <div>
              <h2 className="text-2xl font-semibold">Publication</h2>
            </div>
            <div className="grid gap-10 lg:grid-cols-2">
              <div className="space-y-6 text-sm leading-relaxed text-white/90">
                <div>
                  <p className="font-semibold">Ovarian Cancer and ART</p>
                  <p>Chittawar P.B., The Art and Science of ART. Ed Dr. Sunita Tandulwadkar</p>
                </div>
                <div>
                  <p className="font-semibold">Assisted Reproductive Therapies and Diabetes</p>
                  <p>Chittawar P.B., Bajaj S., Women's Health and Diabetes. Ed. Dr. Sarita Bajaj</p>
                </div>
                <div>
                  <p className="font-semibold">Energy Sources in Laparoscopic Hysterectomy</p>
                  <p>Chittawar P.B., A textbook and color atlas of laparoscopic hysterectomy. Ed. Dr. B. Ramesh</p>
                </div>
                <div>
                  <p className="font-semibold">Minimally Invasive Surgical Techniques versus Open Myomectomy for Uterine Fibroids</p>
                  <p>Bhave Chittawar P, Franik S., Pouwer A.W., Farquhar C., Cochrane Database of Systematic Reviews 2014, Issue 10. Art. No.: CD004638. DOI: 10.1002/14651858.CD004638.pub3</p>
                </div>
                <div>
                  <p className="font-semibold">Predictive factors for pregnancy after intrauterine insemination</p>
                  <p>A prospective study of factors affecting outcome (Journal of Human Reproductive Sciences, 2010, Sep-Dec; 3(3):129-134) Mohan S Kamath, Priya Bhave and Korula George</p>
                </div>
                <div>
                  <p className="font-semibold">Kisspeptin</p>
                  <p>Role in reproduction and implications for infertility management, Priya B Chittawar (Journal of Human Reproductive Sciences, 2012 May-Aug; 5(2):228)</p>
                </div>
                <div>
                  <p className="font-semibold">Poor responders: Is it time to consider changing the nomenclature?</p>
                  <p>Chittawar P.B., Chittawar S., J Mid-life Health 2012; 3:109-10</p>
                </div>
              </div>

              <div className="space-y-6 text-sm leading-relaxed text-white/90">
                <div>
                  <p className="font-semibold">Hysteroscopic diagnosis and successful management of an acquired uterine arteriovenous malformation by percutaneous embolotherapy</p>
                  <p>Chittawar P.B., Patel K, Agrawal P, Bhandari S.J. Midlife Health. 2013 Jan-Mar; 4(1): 57-59</p>
                </div>
                <div>
                  <p className="font-semibold">Laparoendoscopic single-site surgery in gynecology</p>
                  <p>LESS is actually how much less? Chittawar P.B., Magon N., Bhandari S., J Mid-life Health 2013; 4:46-51</p>
                </div>
                <div>
                  <p className="font-semibold">Does centrifugation and semen processing with swim up at 37°C yield sperm with better DNA integrity compared to centrifugation and processing at room temperature?</p>
                  <p>Repalle D., Chittawar P.B., Bhandari S., Joshi G., Paranjape M., Joshi C., Journal of Human Reproductive Sciences 2013; 6:23-6</p>
                </div>
                <div>
                  <p className="font-semibold">Individualized ovarian stimulation</p>
                  <p>Chittawar P.B., Chapter 48 Textbook of Infertility. Ed. Dr. Kamini Rao, pg 571-576</p>
                </div>
                <div>
                  <p className="font-semibold">Hysteroscopic Findings in an Unusual Case of Adenomyosis</p>
                  <p>Chittawar P.B., World Journal of Laparoscopic Surgery 2013; 6(2):00-00</p>
                </div>
                <div>
                  <p className="font-semibold">GnRH Agonist in Infertility</p>
                  <p>Chittawar P.B., Mahla A. Manual of Odisha Fertility Forum July-December 2013; 1:29-33</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
